import React,{useContext} from "react";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
export default () => {//this component is used to go back to the client portal page.
    const BtnName = 'GO TO ESTIMATE'
    let PageView = useContext(ViewMangementContext)
    let Record = useContext(RecordsManagementContext)
    let ClientPortalData = Record.CP_PageDetails
    const backButtonLink = () => { //go back to the client portal
        PageView.Set('CLIENT_PORTAL')
    }
    return (
        ClientPortalData ?
            <button  className='btn btn-dark btn-sm '
                     onClick={() => backButtonLink()}>
                <b>{BtnName}</b></button>
            :
            <></>
    )
}

